export const teacherAccessibleUrls = () => {
  return [
    "inbox-type",
    "my-courses",
    "add-courses",
    "teaching-home",
    "inbox-teacher",
    "course-details",
    "duplicate-course",
    "create-new-teaching-account",
  ];
};

export const studentAccessibleUrls = () => {
  return [
    "settings",
    "calendar",
    "verify-otp",
    "my-learning",
    "certificates",
    "learner-home",
    "inbox-student",
    "my-track-details",
    "add-phone-number",
    "my-course-details",
    "certificate-details",
    "change-email-address",
    "course-details-learner",
    "create-new-teaching-account",
  ];
};
